module.exports = __webpack_public_path__ + "static/img/modelcenter.0fc0d70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/modelcenter.png
// module id = s2Th
// module chunks = 0